import React from "react";
import { InputNumber, Tooltip, Button } from "antd";


export default function NumberFilter(props) {
  return (
    <>
    <Tooltip placement="right" title={props.title}>
      <InputNumber
        defaultValue={props.defaultValue}
        min={props.min}
        max={props.max}
        onChange={props.onChange}
        style={{ width: "75%", marginRight: "5px" }}
      />
    </Tooltip>
    <Tooltip placement="right" title={props.info}>
      <Button type="primary" shape="circle" icon="info" />
    </Tooltip>
    </>
  );
}
